import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MobileNavComponent } from '../main/mobile-nav/mobile-nav.component';
import { MobileHeaderComponent } from '../main/mobile-header/mobile-header.component';
import { RouterModule, Routes } from '@angular/router';
import { RolesAccessData } from './services/auth/aclData';
import { KeysPipe } from './pipes/keys.pipe';
import { FilterPipe } from './pipes/filter.pipe'
import { OrganizationService } from './services/organization.service';
import { DatefilterPipe } from './pipes/datefilter.pipe'
import { DownloadService } from './services/html-png/html-png.service';
import { SuccessToastComponent } from 'app/shared/components/success-toast/success-toast.component';
import { ErrorToastComponent, WarningToastComponent } from './components/error-toast/error-toast.component';
import { ListFilterPipe } from './pipes/list-filter.pipe';
import { FieldFilterPipe } from './pipes/field-filter.pipe';
import { ChartModule } from 'angular-highcharts';
import { PdfConvertorDirective } from './components/pdf-convertor/pdf-convertor.directive';
import { DisapprovalComponent } from './components/disapproval/disapproval.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NotificationService } from './services/notification.service';
import { DeletePopupComponent } from './components/delete-popup/delete-popup.component';
import { AuthGuard } from './services/auth/auth.guard';
import { EmptyfieldfillerDirective } from './directives/emptyfieldfiller.directive';
import { UnarchiveInactivePopupComponent } from './components/unarchive-inactive-popup/unarchive-inactive-popup.component';
import {
    MatDatepickerModule,
    MAT_DATE_LOCALE,
    MatAutocompleteModule,
    MatTooltipModule
} from '@angular/material';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MobileFilterComponent } from './components/mobile-filter/mobile-filter.component';
import { AuthService } from './services/auth/auth.service';
import { ImageGalleryComponent } from './components/image-gallery/image-gallery.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ShareReportPopupComponent } from './components/share-report-popup/share-report-popup.component';
import { UploadFileComponentComponent } from './components/upload-file-component/upload-file-component.component';
import { EmailPopupComponent } from './components/email-popup/email-popup.component';
import { ProxyUsersPopupComponent } from './components/proxy-users-popup/proxy-users-popup.component';
import { ProfileCardPopupComponent } from './components/profile-card-popup/profile-card-popup.component';
import { TalentManagementFilterComponent } from './components/talent-management-filter/talent-management-filter.component';
import { ListWorkgroupsPopupComponent } from './components/list-workgroups-popup/list-workgroups-popup.component';
import {WorkgroupService} from '../shared/services/workgroup-services/workgroup.service';
import { SecondsToTimePipe } from './pipes/seconds-to-time.pipe';
import { TextMaskModule } from 'angular2-text-mask';

// internationalization
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { AddressFormatPipe } from './pipes/address-format.pipe';
import { AddressFormatInputComponent } from './components/address-format-input/address-format-input.component';
import { AddressFormatDisplayComponent } from './components/address-format-display/address-format-display.component';
import { EmptyFieldFillerPipe } from './pipes/empty-field-filler.pipe';
import { AssociateListDropdownComponent } from './components/associate-list-dropdown/associate-list-dropdown.component';
import { DuplicateAssociateComponent } from './components/duplicate-associate/duplicate-associate.component';
import { DateDurationPipe } from './pipes/date-duration.pipe';
import { SearchPipe } from './pipes/search.pipe';
import { ChangePasswordPopupComponent } from './components/change-password-popup/change-password-popup.component';
import { FixTimezonePipe } from './pipes/fix-timezone.pipe';
import { ContactNumberComponent } from './components/contact-number/contact-number.component';
export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

// services
import {TrainingService} from './services/training.service';


import { CommonDbService } from './services/common-db.service';
import {NgxMaskModule} from 'ngx-mask';
import {VisualizationComponent} from './components/visualization/visualization.component';
import { ForceLogoutPopupComponent } from './components/force-logout-popup/force-logout-popup.component';
import { NgModelChangeDebouncedDirective } from './directives/ng-model-change-debounced.directive';
import { HighlightSearch } from './pipes/text-highligth.pipe';
// import { ReversePipe } from './pipes/reverse.pipe'




@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        ChartModule,
        FormsModule,
        ReactiveFormsModule,
        MatDatepickerModule,
        MatCheckboxModule,
        MatTooltipModule,
        MatProgressSpinnerModule,
        MatAutocompleteModule,
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        }),
        TextMaskModule,
        NgxMaskModule.forRoot(),
    ],

    declarations: [MobileNavComponent, MobileHeaderComponent, KeysPipe, FilterPipe, DatefilterPipe,
        SuccessToastComponent, ErrorToastComponent, WarningToastComponent, ListFilterPipe, FieldFilterPipe, PdfConvertorDirective,
        DisapprovalComponent, DeletePopupComponent, EmptyfieldfillerDirective, UnarchiveInactivePopupComponent,
        MobileFilterComponent, ImageGalleryComponent, ShareReportPopupComponent,
        UploadFileComponentComponent, EmailPopupComponent, ProxyUsersPopupComponent, ProfileCardPopupComponent,
        ListWorkgroupsPopupComponent, TalentManagementFilterComponent, SecondsToTimePipe, AddressFormatPipe, AddressFormatInputComponent,
         AddressFormatDisplayComponent,
         EmptyFieldFillerPipe,
         AssociateListDropdownComponent,
         DuplicateAssociateComponent,
        DateDurationPipe,
        //  HighlightSearch,
         SearchPipe,
         ChangePasswordPopupComponent,
         FixTimezonePipe,
         ContactNumberComponent,
         VisualizationComponent,
         ForceLogoutPopupComponent,
         NgModelChangeDebouncedDirective
        //  ReversePipe,
        ],
    exports: [
        MobileNavComponent,
        MobileHeaderComponent,
        KeysPipe,
        FilterPipe,
        ListFilterPipe,
        FieldFilterPipe,
        PdfConvertorDirective,
        ChartModule,
        EmptyfieldfillerDirective,
        SecondsToTimePipe,
        AddressFormatPipe,
        AddressFormatInputComponent,
        AddressFormatDisplayComponent,
        EmptyFieldFillerPipe,
        DateDurationPipe,
        AssociateListDropdownComponent,
        DuplicateAssociateComponent,
        SearchPipe,
        ChangePasswordPopupComponent,
        FixTimezonePipe,
        ContactNumberComponent,
        VisualizationComponent,
        ForceLogoutPopupComponent,
        NgModelChangeDebouncedDirective
        // ReversePipe
    ],
    entryComponents: [SuccessToastComponent, ErrorToastComponent, WarningToastComponent, DisapprovalComponent, UploadFileComponentComponent, EmailPopupComponent,
         DeletePopupComponent, UnarchiveInactivePopupComponent, MobileFilterComponent, ImageGalleryComponent, ShareReportPopupComponent,
         ProfileCardPopupComponent, TalentManagementFilterComponent, ProxyUsersPopupComponent, ListWorkgroupsPopupComponent,
         DuplicateAssociateComponent, ChangePasswordPopupComponent, ForceLogoutPopupComponent ],

    providers: [RolesAccessData, OrganizationService , DownloadService, NotificationService, AuthGuard, WorkgroupService,CommonDbService,TrainingService,
        { provide: MAT_DIALOG_DATA, useValue: {} },
        { provide: MatDialogRef , useValue: {} }]

})
export class SharedModule { }
